import { z } from "zod";
import stringSchema from "@/lib/utils/stringSchema";


const formSchema = z.object({
  date: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date()),
  account_id: stringSchema({ key: "Account", required: true }),
  entity_id: stringSchema({ key: "Entity", required: true }),
  nmq_entity_id: stringSchema({ key: "NMQ Entity", required: true }),
  service_period_start: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date()),
  service_period_end: z.preprocess((arg) => {
    if (typeof arg === "string" || arg instanceof Date) {
      return new Date(arg);
    }
    return arg;
  }, z.date()),
  sow_ids: z.array(z.string()).optional().nullable(),
  reference_no: z.string(),
  auto_invoice_id: z.string().optional().nullable(),
  order_ref_no: z.string(),
  payment_terms: z.string(),
  invoicing_queries: z.string(),
  client_address: z.string(),
  client_contact: z.string(),
  client_vat: z.string().optional().nullable(),
  currency_type: z.string(),
  service_name: z.string().optional().nullable(),
  notes: z.string().optional().nullable(),
  calculated_data_html: z.string().optional().nullable(),
  additional_type: z.string().optional().nullable(),
  additional_amount_description: z.string().optional().nullable(),
  additional_cost_discount: z.union([z.number(), z.string()]).optional().nullable(),
  total_amount: z.union([z.number(), z.string()]).optional().nullable(),
  total_sub_amount: z.union([z.number(), z.string()]).optional().nullable(),
  vat_amount: z.union([z.number(), z.string()]).optional().nullable(),
}).refine((data) => data.service_period_start <= data.service_period_end, {
  message: "Service start date cannot be greater than service end date",
  path: ["service_period_start"],
}).refine((data) => {
  return !(data.additional_cost_discount != 0) || (data.additional_cost_discount && data.additional_amount_description);
}, {
  message: "Additional amount description is required when additional cost discount is provided",
  path: ["additional_amount_description"],
});;

export default formSchema;
